// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"238":"28f9cb19f43d06aa","578":"3a80ad8d35ea7096","776":"37712a4ee863c73c"}[chunkId] + ".css";
};